($ => {

	'use strict';

	const header = document.querySelector('.header')

	function init() {

		if(window.outerWidth < 975) {
			headerMobile()
		}
        
	}

	function headerMobile() {

		const burger = header.querySelector('.header__burger')

		const nav = header.querySelector('.header__nav')

		nav.style.display = 'none'

		const lang = header.querySelector('.header__lang')

		burger.addEventListener('click', () => {
			header.classList.toggle('fixed')
			burger.classList.toggle('active')
			if(!nav.classList.contains('active')) {
				nav.style.display = 'flex'
				setTimeout(() => {
					nav.classList.add('active')
				}, 50)
				burger.ariaExpanded = true
				fixedScroll(true)
			} else {
				setTimeout(() => {
					nav.style.display = 'none'
				}, 450)
				nav.classList.remove('active')
				burger.ariaExpanded = false
				fixedScroll(false)
			}
		})

		lang.querySelector('.header__lang__toggler').addEventListener('click', () => {
			lang.classList.toggle('active')
		})

		nav.querySelectorAll('a[href*="#"]').forEach((a) => {
			a.addEventListener('click', () => {
				header.classList.remove('fixed')
				burger.classList.remove('active')
				setTimeout(() => {
					nav.style.display = 'none'
				}, 450)
				nav.classList.remove('active')
				burger.ariaExpanded = false
				fixedScroll(false)
			})
		})

	}

	function fixedScroll(fixed) {
		if(fixed) {
			body.dataset.y = window.scrollY
			setTimeout(() => {
				body.classList.add('fixed')
			}, 450)
		} else {
			body.classList.remove('fixed')
			window.scrollTo(0, body.dataset.y)
		}
	}

	$(document).ready(() => {
		init();
	});

})(jQuery);
